import React from 'react';

import { Role } from 'app/constants/role';
import { MenuItemData } from 'app/model/menu-item';

import { HeaderMenu } from './header-menu';

const options: MenuItemData[] = [
    {
        name: 'Home',
        icon: 'home',
        routerLink: '/',
    },
    {
        name: 'Users',
        icon: 'manage_accounts',
        routerLink: '/users',
        role: Role.ADMIN,
    },
    {
        name: 'Health',
        icon: 'health_and_safety',
        routerLink: '/tools/health',
    },
    {
        name: 'KPI Dashboard',
        icon: 'multiline_chart',
        routerLink: '/tools/kpi',
        role: Role.DASHBOARD_USER,
    },
    {
        name: 'ML Versions',
        icon: 'model_training',
        routerLink: '/ml-versions',
        role: Role.ADMIN,
    },
    {
        name: 'API Doc',
        icon: 'library_books',
        routerLink: '/api/doc',
        target: '_blank',
    },
];

export class AuxMenu extends React.Component {
    public render(): React.ReactNode {
        return <HeaderMenu options={options} icon='menu' />;
    }
}
